import {
  INVALID_FIELDS,
  passwordPatternChecking,
  YupString,
  YupStringWithoutRequired,
} from '.';
import * as Yup from 'yup';

export const createTagSchema = Yup.object().shape({
  key: YupString,
  dataType: YupString,
  resource: YupString,
  description: YupStringWithoutRequired,
});

export const changePasswordSchema = Yup.object().shape({
  previousPassword: YupString,
  proposedPassword: YupString.matches(
    passwordPatternChecking,
    INVALID_FIELDS.PASSWORD_PATTERN,
  ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('proposedPassword')], INVALID_FIELDS.PASSWORD_MATCH)
    .required(INVALID_FIELDS.REQUIRED),
});

export const webhookRuleSchema = Yup.object().shape({
  name: YupString,
  conditions: Yup.array().of(
    Yup.object().shape({
      key: YupString,
      regex: Yup.string()
        .required(INVALID_FIELDS.REQUIRED)
        .test(
          'regex',
          'validation.messages.incorrectRegexFormat',
          function (regex) {
            if (regex) {
              try {
                new RegExp(regex);
                return true;
              } catch (_error) {
                return false;
              }
            }
            return false;
          },
        ),
    }),
  ),
  method: YupString,
  endpointUrl: Yup.string()
    .required(INVALID_FIELDS.REQUIRED)
    .test('endpointUrl', 'validation.messages.incorrectUrlFormat', url => {
      if (!url) return false;
      const regex =
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
      const newUrl = url.replace(/[${}=?&-]/g, 'rp');
      const isValid = regex.test(newUrl);
      return isValid;
    }),
  headers: Yup.array().of(
    Yup.object().shape({
      key: YupString,
      value: YupString,
    }),
  ),
  body: Yup.string().test(
    'json',
    'validation.messages.incorrectJsonFormat',
    body => {
      if (body) {
        try {
          let newBody = body;
          const list = body.match(/\${+[A-z]+[A-z0-9{0,}]+}/gm);
          list?.forEach(item => {
            const stringifyItem = item.replace('${', '"').replace(/}/, '"');
            newBody = newBody.replace(item, stringifyItem);
          });
          const isParsed = JSON.parse(newBody);
          return !!isParsed;
        } catch (_error) {
          return false;
        }
      }
      return true;
    },
  ),
});
